import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { geraStringAleatoria } from "../../utils/geraStringAleatoria";

const useStyles = makeStyles((theme) => ({
  dialogTitle: { background: "#0369a1", color: "#fff", padding: theme.spacing(2) },
  infoBox: { background: "#dbeafe", border: "1px solid #93c5fd", borderRadius: 8, padding: theme.spacing(1.5), marginBottom: theme.spacing(2) },
  infoText: { fontSize: "0.82rem", color: "#1e40af", lineHeight: 1.6 },
}));

const DEFAULT = {
  msgSemAgendamentos: "Você não possui agendamentos futuros no momento.",
};

const FlowBuilderScAgendamentosModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const [cfg, setCfg] = useState(DEFAULT);

  useEffect(() => {
    if (open === "edit" && data?.data?.data) {
      setCfg({ ...DEFAULT, ...data.data.data });
    } else if (open === "create") {
      setCfg(DEFAULT);
    }
  }, [open, data]);

  const handleSave = () => {
    const label = "SC — Agendamentos";
    if (open === "edit") {
      onUpdate(data.id, { data: { label, data: cfg } });
    } else {
      onSave({ label, data: cfg, id: geraStringAleatoria(30) });
    }
    close();
  };

  return (
    <Dialog open={!!open} onClose={close} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle className={classes.dialogTitle}>Sys Clínica — Agendamentos</DialogTitle>
      <DialogContent>
        <Box className={classes.infoBox}>
          <Typography className={classes.infoText}>
            Consulta os agendamentos futuros do paciente na API do Sys Clínica usando o CPF cadastrado.<br />
            Envia a lista formatada ou a mensagem "sem agendamentos" se não houver nenhum.
          </Typography>
        </Box>

        <TextField
          label="Mensagem quando sem agendamentos"
          value={cfg.msgSemAgendamentos}
          onChange={(e) => setCfg({ ...cfg, msgSemAgendamentos: e.target.value })}
          fullWidth margin="dense" variant="outlined" multiline minRows={2}
        />

        <Box style={{ marginTop: 16, padding: 12, background: "#eff6ff", borderRadius: 8, border: "1px solid #93c5fd" }}>
          <Typography style={{ fontSize: "0.8rem", color: "#1e40af", fontWeight: 600, marginBottom: 4 }}>Saídas disponíveis</Typography>
          <Typography style={{ fontSize: "0.8rem", color: "#0369a1" }}>
            🔵 <strong>encontrou</strong> — paciente tem agendamentos futuros (mensagem enviada)<br />
            ⚫ <strong>semAgendamentos</strong> — nenhum agendamento futuro encontrado<br />
            🔴 <strong>erro</strong> — falha na API ou integração inativa
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color="secondary">Cancelar</Button>
        <Button onClick={handleSave} color="primary" variant="contained">Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderScAgendamentosModal;
